import { useState } from "react";
import useSWR from "swr";

import { Card } from "@/components/ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import { useToast } from "@/components/ToastProvider";
import { post } from "@/lib/api";

const fetcher = (url: string) => fetch(url, { credentials: "include" }).then((res) => res.json());

export function AutopilotSettings() {
  const { data, mutate } = useSWR("/marketing/autopilot/status", fetcher);
  const { push } = useToast();
  const [mode, setMode] = useState("suggest");

  const available = data?.available_modes ?? {};

  const handleSave = async () => {
    try {
      await post("/marketing/autopilot/set-mode", { mode });
      push({ title: "Autopilot updated", message: `Mode set to ${available[mode] ?? mode}.` });
      await mutate();
    } catch (error) {
      push({
        title: "Unable to change mode",
        message: error instanceof Error ? error.message : "Try again later.",
        variant: "destructive",
      });
    }
  };

  return (
    <Card className="space-y-3 border-border/70 bg-background/40 p-4">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm font-semibold text-foreground">Marketing Autopilot</p>
          <p className="text-xs text-muted-foreground">Control automation vs HITL.</p>
        </div>
        <p className="text-[11px] uppercase text-muted-foreground">Current: {data?.label ?? "Suggest"}</p>
      </div>
      <Select value={mode} onValueChange={setMode}>
        <SelectTrigger className="bg-background/50 text-foreground">
          <SelectValue placeholder="Select mode" />
        </SelectTrigger>
        <SelectContent className="bg-background/40 text-foreground">
          {Object.entries(available).map(([key, label]) => (
            <SelectItem key={key} value={key}>
              {label as string}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Button onClick={() => void handleSave()}>Update mode</Button>
      <p className="text-xs text-muted-foreground">Last updated {data?.updated_at ?? "–"} by {data?.updated_by ?? "system"}</p>
    </Card>
  );
}
